import { PRODUCT_TYPES } from 'services/ProductTypeState'
import type { CartItem } from 'stores/cartStore/CartItem'
import { ReactComponent as CartTiles } from '../../../../../icons/assets/CartTiles.svg'
import TilesThumbnail from './TilesThumbnail'
import BookThumbnail from './BookThumbnail'
import * as S from './ProductThumbnail.styles'

type ProductThumbnailProps = {
  item: CartItem
}

function ProductThumbnail({ item }: ProductThumbnailProps) {
  return (
    <S.Container data-testid={`cart-item-thumbnail-${item.id}`}>
      {renderThumbnail(item)}
    </S.Container>
  )
}

function renderThumbnail(item: CartItem) {
  switch (item.productType) {
    case PRODUCT_TYPES.CLASSIC:
      return <TilesThumbnail item={item} />
    case PRODUCT_TYPES.PHOTO_BOOK:
      return <BookThumbnail item={item} />
    default:
      return (
        <S.FallbackIcon>
          <CartTiles />
        </S.FallbackIcon>
      )
  }
}

export default ProductThumbnail
